var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"styled-search"},[_c('Search',{ref:"search",class:{
            'styled-search__search-bar': true,
            'styled-search__search-bar--focused': _vm.isFocused,
        },attrs:{"afterType":_vm.afterType,"hideSearchIcon":_vm.hideSearchIcon,"defaultValue":_vm.defaultValue,"placeholder":_vm.placeholder,"inputRef":"searchInput"},on:{"focus":_vm.handleFocus,"blur":_vm.blur,"submit":function($event){return _vm.$emit('submit')},"input":_vm.onInput}}),_c('button',{class:{
            'styled-search__close-btn': true,
            'styled-search__close-btn--focused': _vm.isFocused,
        },attrs:{"type":"button"},on:{"click":_vm.handleClose}},[_c('i',{staticClass:"icon-X-01"})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }